export default __webpack_public_path__ + "static/media/event-3.bd05c324.jpg";